export default __webpack_public_path__ + "adobe-indesign.32d74104.png";